const privacyPolicy = {
  title: "Privacy Policy",
  sections: [
    {
      heading: "1. Introduction",
      paragraphs: [
        'Elite Dental Solutions ("we," "our," or "us") respects your privacy and is committed to protecting your personal data.',
        "This privacy policy explains how we collect, use, and protect your personal information when you use our website and services.",
      ],
    },
    {
      heading: "2. Information We Collect",
      paragraphs: ["We collect information that you provide directly to us, including:"],
      bullets: [
        "Name and contact information",
        "Medical and dental history",
        "Appointment requests and preferences",
        "Communications with us",
        "Payment information",
      ],
    },
    {
      heading: "3. How We Use Your Information",
      paragraphs: ["We use your information to:"],
      bullets: [
        "Provide dental services and process appointments",
        "Communicate about your treatment",
        "Send appointment reminders",
        "Process payments",
        "Improve our services",
        "Comply with legal obligations",
      ],
    },
    {
      heading: "4. Data Protection",
      paragraphs: [
        "We implement appropriate security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. Your medical information is handled in accordance with applicable healthcare privacy laws and regulations.",
      ],
    },
    {
      heading: "5. Your Rights",
      paragraphs: ["You have the right to:"],
      bullets: [
        "Access your personal information",
        "Correct inaccurate information",
        "Request deletion of your information",
        "Object to processing of your information",
        "Receive a copy of your information",
      ],
    },
    {
      heading: "6. Cookies and Tracking",
      paragraphs: [
        "Our website uses cookies and similar tracking technologies to improve your browsing experience. You can control cookie settings through your browser preferences.",
      ],
    },
    {
      heading: "7. Contact Information",
      paragraphs: [
        "For questions about this privacy policy or our privacy practices, please contact us at:",
        "Email: info@elitedentalsolutions.com",
        "Phone: +359 897 800 430",
      ],
    },
    {
      heading: "8. Updates to This Policy",
      paragraphs: [
        "We may update this privacy policy from time to time. The latest version will always be available on our website.",
        "Last updated:",
      ],
      lastUpdatedLocale: "en-US",
    },
  ],
};

export default privacyPolicy;

